var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4479 6.61111L14.7733 16.0553C14.7152 16.8693 14.0378 17.5 13.2217 17.5H6.78521C5.96911 17.5 5.29176 16.8693 5.23361 16.0553L4.55903 6.61111M8.44792 9.72222V14.3889M11.559 9.72222V14.3889M12.3368 6.61111V4.27778C12.3368 3.84822 11.9886 3.5 11.559 3.5H8.44792C8.01836 3.5 7.67014 3.84822 7.67014 4.27778V6.61111M3.78125 6.61111H16.2257",
    stroke: "#000000",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconBlack);
export default __webpack_public_path__ + "static/media/delete_icon_black.b0cc02d2253774f4f0dee6a1b0fec092.svg";
export { ForwardRef as ReactComponent };